import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Perfil from "@/components/Perfil";
import Estadisticas from "@/components/Estadisticas";
import Trayectoria from "@/components/Trayectoria";
import Galeria from "@/components/Galeria";
import Videos from "@/components/Videos";
import Contacto from "@/components/Contacto";
import Admin from "@/pages/Admin";

function Home() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <Perfil />
        <Estadisticas />
        <Trayectoria />
        <Galeria />
        <Videos />
        <Contacto />
      </main>
      <footer className="border-t border-neutral-800 py-10 px-6" data-testid="site-footer">
        <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4">
          <img src="/logo-horizontal.webp" alt="Cristian Díaz — logo oficial" className="h-7 w-auto" data-testid="footer-logo" />
          <p className="text-xs text-neutral-500 font-tech uppercase tracking-[0.25em]">
            © 2026 · El Cacique · Hecho con garra
          </p>
        </div>
      </footer>
    </>
  );
}

function App() {
  return (
    <div className="App bg-[#050505] text-neutral-100 overflow-x-clip">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
